/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:43:43
 * @LastEditTime: 2023-02-17 14:49:18
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\intelligentize-report\industry-data\index.js
 * 行业数据
 */

import industryDataCoverRouter from './modules/industryDataCoverRouter'
const industryDataRouter = [].concat(industryDataCoverRouter)

export default industryDataRouter
